import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from '@material-ui/core';

import { Loaders } from 'components';
import { UserSegmentFragment, ContentEmailHistoryFragment } from 'api';

import SentEmailRow from './SentEmailRow';

interface IProps {
  segments: UserSegmentFragment[];
  sentEmails: ContentEmailHistoryFragment[];
  isExhausted: boolean;
  sentinelRef(node: Element): void;
}

const SentEmails: FC<IProps> = props => {
  const { sentEmails, segments, isExhausted, sentinelRef } = props;
  const { t } = useTranslation();

  return (
    <Fragment>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell colSpan={2}>
                <Typography variant="subtitle2">{t('common:email_plural')}</Typography>
              </TableCell>
              <TableCell align="center">{t('common:recipient_plural')}</TableCell>
              <TableCell align="center">{t('common:open_plural')}</TableCell>
              <TableCell colSpan={2}>{t('common:click_plural')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sentEmails.map((emailItem, index: number) => (
              <SentEmailRow key={index} item={emailItem} index={index} segments={segments} />
            ))}
          </TableBody>
        </Table>
      </Paper>
      {!isExhausted && (
        <div ref={sentinelRef}>
          <Loaders.Standard />
        </div>
      )}
    </Fragment>
  );
};

export default SentEmails;
